import { CancelToken } from 'axios'

import { portalApi } from '@/axios'

import { Business, User } from '@/classes/models'

export default class UserService {
  /**
   * Get all users.
   *
   * @param {PaginationRequest} parameters
   *
   * @return {Promise}
   */
  static getAll (parameters) {
    const cancelToken = CancelToken.source()

    let request = portalApi.get(`/user/users`, {
      cancelToken: cancelToken.token,
      params: parameters ? parameters.getParams() : null
    }).then(response => {
      return response.data
    })

    request.then(response => {
      // Set pagination
      response.totalCount = response.numberOfResults

      // Map to User
      response.data = response.results.map(user => {
        return new User(user)
      })

      return response
    }).catch(error => {
      return Promise.reject(error)
    })

    return { request, cancelToken }
  }

  /**
   * Get user by id.
   *
   * @param {string} userId
   * @param {QueryRequest} parameters
   *
   * @return {Promise}
   */
  static get (userId, parameters) {
    return portalApi.get(`/users/${userId}`, {
      params: parameters ? parameters.getParams() : null
    }).then(response => {
      // Map to User
      return new User(response.data)
    }).catch(error => {
      return Promise.reject(error)
    })
  }

  /**
   * Create a user
   *
   * @param {Object} data
   *
   * @return {Promise}
   */
  static add (data) {
    return portalApi.post(`/users`, data).then(response => {
      // Map to User
      return new User(response.data)
    })
  }

  /**
   * Update a user
   *
   * @param {string} userId
   * @param {Object} data
   *
   * @return {Promise}
   */
  static update (userId, data) {
    return portalApi.put(`/users/${userId}`, data)
  }

  /**
   * Update current user
   *
   * @param {object} data
   *
   * @return {Promise}
   */
  static updateCurrent (data) {
    return portalApi.patch(`users`, data)
  }

  /**
   * Send password reset email
   *
   * @param {string} userId
   */
  static sendPasswordResetEmail (userId) {
    return portalApi.post(`users/${userId}/password-reset-email`)
  }

  /**
   * Modify a user's login
   *
   * @param {string} userId
   * @param {object} data
   */
  static updateLogin (userId, data) {
    return portalApi.put(`users/${userId}/login`, data)
  }

  /**
   * Delete a user
   *
   * @param {string} userId
   */
  static deleteUser (userId) {
    return portalApi.delete(`users/${userId}`)
  }

  /**
   * Get businesses for a user
   */
  static getBusinesses (parameters) {
    const cancelToken = CancelToken.source()

    let request = portalApi.get(`/user/businesses`, {
      params: parameters ? parameters.getParams() : null
    }).then(response => {
      return response.data
    })

    request.then(response => {
      // Set pagination
      response.totalCount = response.numberOfResults

      // Map to Business
      response.data = response.results.map(business => {
        return new Business(business)
      })

      return response
    }).catch(error => {
      return Promise.reject(error)
    })

    return { request, cancelToken }
  }

  static getContext (parameters) {
    const cancelToken = CancelToken.source()

    let request = portalApi.get(`/user/contexts`, {
      params: parameters ? parameters.getParams() : null
    }).then(response => {
      return response.data
    })

    request.then(response => {
      // Set pagination
      response.totalCount = response.numberOfResults

      response.data = response.results

      return response
    }).catch(error => {
      return Promise.reject(error)
    })

    return { request, cancelToken }
  }
}
